module.exports = function getResource(label, vars = []) {
    let resources = {
        storesAndServices: 'Magasins et services',
        home: 'Accueil',
        shop: 'Magasiner',
        offers: 'Offres',
        me: 'Moi',
        signIn: 'Ouvrir une session',
        community: 'Collectivité',
        stores: 'Magasins',
        tooltip: 'Ouvrez une session (ou inscrivez-vous!) pour les offres, les points et plus encore.'
    };
    return resources[label];
};
